import { extractImageFrames, clampTo } from '../../tools';
import type { KieModelConfig } from '../types';

export const klingConfigs: Record<string, KieModelConfig> = {
    'kling-v3-turbo': {
        // https://kie.ai/kling-3-0-turbo?model=kling%2Fv3-turbo-text-to-video
        // https://kie.ai/kling-3-0-turbo?model=kling%2Fv3-turbo-image-to-video
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, imagePrompt, duration, aspectRatio, quality, modelUi } = params;
            const frameMode = modelUi?.frameMode;
            // 图生视频模式
            if (frameMode === 'first') {
                const [firstImage] = extractImageFrames(imagePrompt);
                return {
                    model: 'kling/v3-turbo-image-to-video',
                    input: {
                        prompt: prompt.slice(0, 2500),
                        duration: clampTo(duration || 5, [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15] as const, 5),
                        resolution: clampTo(quality || '720p', ['720p', '1080p'] as const, '720p'),
                        // 首帧 URL
                        image_urls: [firstImage!],
                    },
                };
            }
            // 文生视频模式
            return {
                model: 'kling/v3-turbo-text-to-video',
                input: {
                    prompt: prompt.slice(0, 2500),
                    aspect_ratio: clampTo(aspectRatio || '16:9', ['16:9', '9:16', '1:1'] as const, '16:9'),
                    duration: clampTo(duration || 5, [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15] as const, 5),
                    resolution: clampTo(quality || '720p', ['720p', '1080p'] as const, '720p'),
                },
            };
        },
    },
};